module.exports = __webpack_public_path__ + "static/media/spider.bf7d3f42.gif";